<app-order-add-account></app-order-add-account>
<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Select a Company</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/orders'><i class="fas fa-arrow-left"></i> Back</button>
      <button class='btn btn-secondary' (click)='openAddAccount()'>+ Add</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='account'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
